import type { Car, CarEvent, CarEventType } from './types.ts'

export const EVENT_CATEGORIES = [
  'maintenance',
  'refuelling',
  'parking',
  'carWash',
  'insurance',
  'other',
] as const

export type EventCategory = (typeof EVENT_CATEGORIES)[number]

// A mileage log, purchase or sale is not a cost, so it belongs to no category and is never counted.
const CATEGORY_OF: Record<CarEventType, EventCategory | undefined> = {
  REPAIR: 'maintenance',
  INSPECTION: 'maintenance',
  TIRE_CHANGE: 'maintenance',
  FUEL: 'refuelling',
  PARKING: 'parking',
  CAR_WASH: 'carWash',
  INSURANCE_PAYMENT: 'insurance',
  TAX: 'other',
  REGISTRATION: 'other',
  FINE: 'other',
  MILEAGE_LOG: undefined,
  SELL: undefined,
  BUY: undefined,
}

export function categoryOf(type: CarEventType): EventCategory | undefined {
  return CATEGORY_OF[type]
}

export function carSubtitle(car: Car): string | undefined {
  const parts = [car.year === undefined ? undefined : String(car.year), car.make, car.model].filter(
    (part): part is string => part !== undefined,
  )
  return parts.length === 0 ? undefined : parts.join(' ')
}

export function eventDescription(event: CarEvent): string | undefined {
  const data = event.data
  switch (data.type) {
    case 'FUEL':
      return data.fuelStation
    case 'REPAIR':
      return data.description ?? (data.items.length > 0 ? data.items.join(', ') : undefined)
    case 'INSPECTION':
      return data.station
    case 'PARKING':
      return data.location
    case 'TIRE_CHANGE':
      return data.brand
    default:
      return undefined
  }
}
